<div class="app-shell">
  <header>
    <div class="header-left">
      <span class="kyloe-logo-mask"></span>
      <h1>Kyloe AI Assist Manager</h1>
    </div>
    <div class="header-right">
      @if (displayName) {
        <span class="user-badge">
          <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/></svg>
          {{ displayName }}
        </span>
      }
    </div>
  </header>

  @if (!isChatRoute) {
    <nav class="tab-bar">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Agent Profiles</a>
      <a routerLink="/connections" routerLinkActive="active">Connections</a>
      <a routerLink="/usage-limits" routerLinkActive="active">Usage &amp; Limits</a>
      <a routerLink="/settings" routerLinkActive="active">Settings</a>
    </nav>
  }

  <main [class.full-height]="isChatRoute">
    <router-outlet></router-outlet>
  </main>
</div>
